const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const waitIdle = (map) =>
  new Promise((resolve) =>
    window.google.maps.event.addListenerOnce(map, "idle", resolve)
  );

const animationStore = new WeakMap();

const smoothPanAndZoom = async (
  targetLatLng,
  finalZoom = 15,
  stepMs = 200,
  mapRef
) => {
  const map = mapRef?.current ?? mapRef;
  if (!map) return;

  let state = animationStore.get(map);
  if (!state) {
    state = { id: 0 };
    animationStore.set(map, state);
  }

  const animationId = ++state.id;

  map.panTo(targetLatLng);
  await waitIdle(map);

  if (state.id !== animationId) return;

  const startZoom = map.getZoom() ?? 6;
  const direction = finalZoom > startZoom ? 1 : -1;

  for (
    let zoom = startZoom + direction;
    direction > 0 ? zoom <= finalZoom : zoom >= finalZoom;
    zoom += direction
  ) {
    if (state.id !== animationId) return;

    map.setZoom(zoom);
    if (stepMs > 0) await sleep(stepMs);
  }
};

export default smoothPanAndZoom;
